import React, { Component } from 'react';
import PhotoThumb from '../PhotoThumb';

export default class LearningActivity extends Component {
  render() {
    const { activity } = this.props;
    return (
      <div className="activity__learning">
        {/* Show learning categories only if activiable exists */}
        {activity?.activiable && (
          <div className="activity__paragraph">
            {(Array.isArray(activity.activiable)
              ? activity.activiable[0]
              : activity.activiable
            )?.learning_activity_categories
              ?.map(category => category.value)
              .join(' | ')}
          </div>
        )}
        
        {/* Always show comment if it exists */}
        {activity.comment && (
          <div className="activity__paragraph">{activity.comment}</div>
        )}
        
        {/* Always show photo if it exists (PhotoThumb handles null gracefully) */}
        <PhotoThumb photoUrl={activity.photo_url} />

      </div>
    );
  }
}
